import { Component, OnInit } from '@angular/core';
import { LiftDetail } from '../../models/lift-detail.model';
import { ActivatedRoute } from '@angular/router';
import { LiftTemperatureService } from '../../services/lift-temperature.service';
import { LiftTemperatureCriteria } from '../../models/lift-temperature.criteria';
import * as moment from 'moment';

import { L10n, setCulture, loadCldr } from '@syncfusion/ej2-base';
import { LoginService } from '../../../user/services/login.service';
declare var require: any;

loadCldr(
  require("cldr-data/main/cs/numbers.json"),
  require("cldr-data/main/cs/ca-gregorian.json"),
  require("cldr-data/supplemental/numberingSystems.json"),
  require("cldr-data/main/cs/timeZoneNames.json"),
  //require('cldr-data/supplemental/weekdata.json') // To load the culture based first day of week
);


L10n.load({
  'cs': {
    datepicker: {
      placeholder: "Vyberte datum",
      today: "Dnes"
    }
  }
});

setCulture('cs');

@Component({
  selector: 'app-lift-temperature',
  templateUrl: './lift-temperature.component.html',
  styleUrls: ['./lift-temperature.component.css']
})
export class LiftTemperatureComponent implements OnInit {
  menu = 'temp';
  lift: LiftDetail;
  liftId: number;
  temperatureCriteria: LiftTemperatureCriteria;
  primaryXAxis: Object;
  primaryYAxis: Object;
  legendSettings: Object;
  chartData: Object[];
  avarageTemperature = 0;
  tooltip: Object;
  marker: Object;

  showLoader = false;

  //Permissions
  canViewErrors: boolean = false;
  canView: boolean = false;
  canControl: boolean = false;
  canViewParameter: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private liftTemperatureService: LiftTemperatureService,
    private loginService: LoginService
  ) { }

  ngOnInit() {
    this.liftId = +this.route.snapshot.paramMap.get('id');
    this.lift = this.route.snapshot.data.lift;
    let serverData = this.route.snapshot.data.temperatures;

    let liftPermission = this.route.snapshot.data.liftPermission;
    if (!liftPermission) {
      liftPermission = [];
    }

    this.canViewErrors = liftPermission.indexOf('2') > -1 || this.loginService.isSuperadmin();
    this.canView = liftPermission.indexOf('0') > -1 || this.loginService.isSuperadmin();
    this.canControl = liftPermission.indexOf('3') > -1 || this.loginService.isSuperadmin();
    this.canViewParameter = liftPermission.indexOf('4') > -1 || this.loginService.isSuperadmin();

    this.temperatureCriteria = new LiftTemperatureCriteria();
    this.temperatureCriteria.liftId = this.liftId;

    this.showLoader = true;
    let templateData = this.createDayGraphTemplate();
    let preparedData = this.handleData(templateData, serverData);
    this.chartData = preparedData;
    this.showLoader = false;

    this.primaryXAxis = {
      valueType: 'Category'
    };

    this.primaryYAxis = {
      labelFormat: '{value}°C'
    };

    this.legendSettings = {
      visible: true
    };

    // Tooltip for chart
    this.tooltip = {
      enable: true
    }

    this.marker = {
      dataLabel: {
        visible: true
      }
    };
  }

  dateFromChanged() {
    this.dataChange();
  }

  dateToChanged() {
    this.dataChange();
  }

  dataChange() {
    this.showLoader = true;
    this.liftTemperatureService
      .getTemperatures(this.temperatureCriteria.paramsExport()).subscribe((data) => {
        let templateData = this.createDayGraphTemplate();
        console.log(data);
        let preparedData = this.handleData(templateData, data);
        this.chartData = preparedData;
        this.showLoader = false;
      });
  }

  createDayGraphTemplate() {
    let dateArray = [];
    let currentDate = moment(this.temperatureCriteria.dateFrom);
    let stopDate = moment(this.temperatureCriteria.dateTo);

    while (currentDate <= stopDate) {
      let day = {
        date: moment(currentDate).format('YYYY-MM-DD'),
        labelDate: moment(currentDate).format('DD.MM.YYYY'),
        value: 0 //this.getRandomInt(25, 31)
      }
      dateArray.push(day);
      currentDate = moment(currentDate).add(1, 'days');
    }

    return dateArray;
  }

  handleData(dataTemplate, serverData) {
    let countAll = 0;

    serverData.forEach(item => {
      let dateToken = item.date.substring(0, 10);
      dataTemplate[dataTemplate.findIndex(el => el.date === dateToken)] = {
        date: dataTemplate[dataTemplate.findIndex(el => el.date === dateToken)].date,
        labelDate: dataTemplate[dataTemplate.findIndex(el => el.date === dateToken)].labelDate,
        value: item.value
      };
      countAll += item.value;
    });

    const filteredArray = dataTemplate.filter(item => item.value > 0);
    if (filteredArray.length > 0) {
      this.avarageTemperature = Math.floor(countAll / filteredArray.length);
    } else {
      this.avarageTemperature = 0;
    }
    return dataTemplate;
  }

  getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
}
